import { egresadosApiCall } from "../../../../axios/apiClient";

const controller = `software`;

export default {
    getSoftwareMe: async () => {

        let response = { success: true };
        const method = "me";

        try {
            const apiResponse = await egresadosApiCall.get(controller, method);
            response.data = apiResponse?.data;
        } catch (error) {
            response = egresadosApiCall.handleCatch(error);
        }
        return response;
    },
    createSoftwareMe: async (data) => {
        let response = { success: true };
        const method = "me";

        try {
            const apiResponse = await egresadosApiCall.post(controller, method, data);
            response.data = apiResponse?.data;
        } catch (error) {
            response = egresadosApiCall.handleCatch(error);
        }
        return response;
    },
    editSoftwareMe: async (data) => {
        let response = { success: true };
        const method = "me";

        try {
            const apiResponse = await egresadosApiCall.put(controller, method, data);
            response.data = apiResponse?.data;
        } catch (error) {
            response = egresadosApiCall.handleCatch(error);
        }
        return response;
    },
    deleteSoftwareMe: async (id) => {
        let response = { success: true };
        const method = `me/${id}`;

        try {
            const apiResponse = await egresadosApiCall.delete(controller, method);
            response.data = apiResponse?.data;
        } catch (error) {
            response = egresadosApiCall.handleCatch(error);
        }
        return response;
    },
    getTipoDominio: async () => {
        let response = { success: true };
        const method = "tipo_dominio";

        try {
            const apiResponse = await egresadosApiCall.get(controller, method);
            response.data = apiResponse?.data;
        } catch (error) {
            response = egresadosApiCall.handleCatch(error);
        }
        return response;
    }, 
    getUso: async () => {
        let response = { success: true };
        const method = "nivel_uso";

        try {
            const apiResponse = await egresadosApiCall.get(controller, method);
            response.data = apiResponse?.data;
        } catch (error) {
            response = egresadosApiCall.handleCatch(error);
        }
        return response;
    }

}